import Lang from '@/modules/core/app/services/Lang';
import { SidePanelPosition } from '@/modules/core/SidePanel/constants/SidePanelPosition';

export class SidePanelConfig {
  openLabel: string;
  closeLabel: string;
  open: boolean;
  showOpenButton: boolean;
  showCloseButton: boolean;
  width: string;
  position: string;
  hasFullPage: boolean;

  constructor(options: Partial<SidePanelConfig> = {}) {
    this.openLabel = options.openLabel ?? Lang.t('flowsidepanel.open-label');
    this.closeLabel = options.closeLabel ?? Lang.t('flowsidepanel.modal-close-label');
    this.open = options.open ?? false;
    this.showOpenButton = options.showOpenButton ?? true;
    this.showCloseButton = options.showCloseButton ?? true;
    this.width = options.width ?? '30%';
    this.position = options.position ?? SidePanelPosition.IS_LEFT;
    this.hasFullPage = options.hasFullPage ?? false;
  }

  get isRight(): boolean {
    return this.position === SidePanelPosition.IS_RIGHT;
  }

  get isLeft(): boolean {
    return this.position === SidePanelPosition.IS_LEFT;
  }
}